import { render, staticRenderFns } from "./surveyPreview.vue?vue&type=template&id=0d81c432&scoped=true"
import script from "./surveyPreview.vue?vue&type=script&lang=js"
export * from "./surveyPreview.vue?vue&type=script&lang=js"
import style0 from "./surveyPreview.vue?vue&type=style&index=0&id=0d81c432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d81c432",
  null
  
)

export default component.exports